<template>
  <nav class="slider-benefits-buttons-wrap">
    <div>
      <button
        type="button"
        class="slider-arrow slider-arrow-prev"
        aria-label="Previous slide"
        @click="sliderStore.goPrev()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 57 57"
        >
          <path
            fill="#fff"
            d="M36.599 39.377 25.72 28.5 36.6 17.599l-3.35-3.349L19 28.5l14.25 14.25 3.349-3.373z"
          />
        </svg>
      </button>
      <button
        type="button"
        class="slider-arrow slider-arrow-next"
        aria-label="Next slide"
        @click="sliderStore.goNext()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 57 57"
        >
          <path
            fill="#fff"
            d="M20.401 39.377 31.28 28.5 20.4 17.599l3.349-3.349L38 28.5 23.75 42.75l-3.349-3.373z"
          />
        </svg>
      </button>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useUpperSliderStore } from '../stores'

const sliderStore = useUpperSliderStore()
</script>